import React from 'react';
import type { ProductionTier } from '../../types/voip';
export function TierBadge({
  tier
}: {
  tier: ProductionTier;
}) {
  return <span className={`inline-flex whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-semibold ${tier.badge}`} data-id="element-180" data-mp="s7josbmx79m3">{tier.label}</span>;
}